// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__2jRAN","Heading":"Header_Heading__12NWV","Form":"Header_Form__14U1C","Searchbar":"Header_Searchbar__9-yNf","Button":"Header_Button__14y5C"};